import React from "react";
import "./ShopByCategories.css";
import { useDispatch } from "react-redux";
import { fetchAllCategoryProductsAsync } from "../../features/listingPage/listingPageSlice";
import { useNavigate } from "react-router";
import { selectUser } from "../../features/auth/authSlice";
import { useSelector } from "react-redux";
import cratoni from "../../assets/cratoni.webp";
import moon from "../../assets/moon.webp";
import funn from "../../assets/funn.webp";

function ShopByCategories() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userDetail = useSelector(selectUser);

  const handleFetchCategoryProduct = (catID, catName) => {
    dispatch(fetchAllCategoryProductsAsync(catID)).then(() => {
      navigate(`/listing-page/${catID}/${catName}`);
    });
  };

  const handleBrandNavigate = (brand, e) => {
    e.preventDefault();
    navigate(`/listing-page/${brand}`);
    e.stopPropagation();
  };

  return (
    <div className="shop-by-categories-container">
      <div className="shop-by-categories-heading-container">
        <span className="shop-by-categories-heading-span">
          Shop By Category
        </span>
      </div>
      <div className="w-full flex flex-col">
        <div className="shop-by-categories-main-container">
          <div
            className="shop-by-categories-each-category-container"
            onClick={() => {
              handleFetchCategoryProduct(9, "Helmets");
            }}
          >
            <img
              loading="lazy"
              src={cratoni}
              alt=""
              className="shop-by-categories-each-category-image"
            />
            <img
              loading="lazy"
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQohbUwx79PkQDbs4YO695jU0OXIAmfqRB-0jAxz05cag&s"
              alt=""
              className="shop-by-categories-each-category-img"
              onClick={(e) => handleBrandNavigate("cratoni", e)}
            />
            <span className="shop-by-categories-each-category-name">
              Helmets
            </span>
            <span className="shop-by-category-each-category-offers">
              30-35% off
            </span>
          </div>
          <div
            className="shop-by-categories-each-category-container"
            onClick={() => {
              handleFetchCategoryProduct(8, "Lights");
            }}
          >
            <img
              loading="lazy"
              src={moon}
              alt=""
              className="shop-by-categories-each-category-image"
            />
            <img
              loading="lazy"
              src="https://www.handshake.fi/wp-content/uploads/2018/06/logo-moon.png"
              alt=""
              className="shop-by-categories-each-category-img"
              onClick={(e) => handleBrandNavigate("moon sports", e)}
            />
            <span className="shop-by-categories-each-category-name">
              Lights
            </span>
            <span className="shop-by-category-each-category-offers">
              25-30% off
            </span>
          </div>
          <div
            className="shop-by-categories-each-category-container"
            onClick={() => handleFetchCategoryProduct(1, "Cockpit")}
          >
            <img
              loading="lazy"
              src={funn}
              alt=""
              className="shop-by-categories-each-category-image"
            />
            <img
              loading="lazy"
              src="https://images.bike24.com/i/mb/0c/67/20/logofunn-3903.jpg"
              alt=""
              className="shop-by-categories-each-category-img"
              onClick={(e) => handleBrandNavigate("funn", e)}
            />
            <span className="shop-by-categories-each-category-name">
              cockpit
            </span>
            <span className="shop-by-category-each-category-offers">
              25-30% off
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ShopByCategories;
